import styled from 'styled-components'
import {colors} from '../../../styles/theme'

export const BreadcrumbBox = styled.div`
  height: 64px;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
  background: #fff;
  border-bottom: 1px solid #ebeffc;
  padding: 0 32px;
`

export const StyledLinkBox = styled.span<{$isGrey?: boolean}>`
  && a {
    font-size: 14px;
    font-weight: bold;

    ${({$isGrey}) => ($isGrey ? `color: ${colors.bksGray50}!important;` : null)}
  }
`
